import styled from 'react-emotion';
import Separator from '@ublend-npm/aulaui-next-web/Separator';
import theme, { colors } from '@ublend-npm/aulaui-next-web/themes/default';

export const HistoryGroupDate = styled('p')`
  margin: 0;
  font-family: ${theme.font.family.workSans};
  font-style: normal;
  font-weight: ${theme.font.weight.semiBold};
  font-size: ${theme.font.size.large};
  line-height: ${theme.font.lineHeight.copy};
  color: ${colors.designSystem.blackOpacity87};
`;

export const HistoryGroupSeparator = styled(Separator)`
  background-color: ${colors.blackAlpha(0.12)};
  margin: 16px 0;
`;

export const Content = styled('div')`
  box-sizing: border-box;
  width: inherit;
  height: inherit;
`;

export const ContentStyle = {
  padding: '32px 24px',
};

export const Footer = styled('div')`
  display: flex;
  justify-content: center;
  padding: 20px;
`;
